import editarAreaCustomerForm from './editarAreaFormModel';
const {
  formField: {
    // DATOS CLIENTE 
    e_name,
    e_description,
  } 
} = editarAreaCustomerForm;

export default {
  [e_name.name]: '',
  [e_description.name]: '',
};

